import React from 'react';

interface AuraLogoProps {
  className?: string;
  width?: number;
  height?: number;
  compact?: boolean;
}

const AuraLogo: React.FC<AuraLogoProps> = ({
  className = '',
  width = 154,
  height = 42,
  compact = false,
}) => {
  const markSize = height;

  return (
    <span
      className={`shrink-0 ${className}`}
      role="img"
      aria-label="Aura"
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          flexDirection: 'row',
          width: compact ? markSize : width,
          height,
        }}
      >
        <img
          src="/brand/aura-app-icon.svg"
          alt=""
          aria-hidden="true"
          draggable={false}
          width={markSize}
          height={markSize}
          className="block shrink-0 rounded-[22%]"
        />
        {!compact && (
          <span
            aria-hidden="true"
            className="ml-[0.28em] whitespace-nowrap font-sans font-black leading-none"
            style={{ fontSize: height * 0.62, letterSpacing: '0.14em' }}
          >
            AURA
          </span>
        )}
      </span>
    </span>
  );
};

export default AuraLogo;
